/**
 * Google Tag Manager loader — gated by the "statistics" consent category.
 *
 * GTM is loaded only after the visitor grants statistics cookies. The
 * consent.ts module already pushes Google Consent Mode v2 updates onto
 * `dataLayer`, so any tags configured inside the GTM container will be
 * gated by Consent Mode state for their respective categories.
 */

import { whenConsent } from '@/Lib/consent';

const GTM_ID = 'GTM-WGLWW2FQ';

/** Inject the GTM container once the visitor has granted statistics consent. */
export function initGtm(): () => void {
    return whenConsent('statistics', () => {
        if (typeof window === 'undefined' || typeof document === 'undefined') return;

        const w = window as unknown as { dataLayer?: unknown[] };
        w.dataLayer = w.dataLayer || [];
        w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

        const f = document.getElementsByTagName('script')[0];
        const j = document.createElement('script');
        j.async = true;
        j.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
        f.parentNode?.insertBefore(j, f);
    });
}